import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import * as yup from "yup";
import { InferType } from "yup";

const schema = yup.object();
type Values = InferType<typeof schema>;

export const ScrollToError: React.FC = () => {
    const fc = useFormikContext<Values>();

    useEffect(() => {
        if (!(fc?.isSubmitting && !fc?.isValidating)) {
            return;
        }

        const errors = Array.prototype.slice
            .call(document.querySelectorAll(".Mui-error"))
            .filter((e) => e.offsetWidth > 0 || e.offsetHeight > 0);
        errors[0]?.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "start",
        });
    }, [fc?.isSubmitting, fc?.isValidating]);

    return null;
};
